module.exports = __webpack_public_path__ + "static/media/paso-4.aca18a20.png";